import ModernDropdown from "components/Elements/ModernDropdown/ModernDropdown";
import React, { useState } from "react";

const FormBuilderSelectElement = ({ field }) => {
  const list = field.fields.options;
  const [titleDropDown, setTitleDropDown] = useState(null);
  const [showDropDownExternal, setShowDropDownExternal] = useState(false);
  const [selectListValue, setSelectListValue] = useState(null);

  const handleChange = (e, itemKey) => {
    setSelectListValue(field.fields.options[itemKey]);
    setTitleDropDown(field.fields.options[itemKey]);
  };
  const [isOpen, setIsOpen] = useState(false);
  const isDropDownOpen = (state) => {
    setIsOpen(state);
  };

  const openDropdown = () => {
    setShowDropDownExternal((prev) => !prev);
  };
  return (
    <div className="select-element">
      <div
        onClick={() => openDropdown()}
        className={`select-title ${
          !isOpen && !selectListValue ? "select-blank" : ""
        }`}
      >
        <span>{field.fields.label}</span>
        {field.fields.required ? (
          <span className="field-required">*</span>
        ) : null}
      </div>
      <ModernDropdown
        isDropDownOpen={isDropDownOpen}
        title={titleDropDown}
        showDropDownExternal={showDropDownExternal}
        setShowDropDownExternal={setShowDropDownExternal}
        handleChange={handleChange}
        selectList={list}
      >
        <div className="">
          <i
            //style={{ color: "#" + buttonsColor }}
            className="fa fa-caret-down"
            aria-hidden="true"
          ></i>
        </div>
      </ModernDropdown>
    </div>
  );
};

export default FormBuilderSelectElement;
